import { TypeInitProps, TypeRequest } from '../../../types';
import { encryptParams } from '../../../utils/index';
import { WEB_AFF_URL } from '../../../utils/urls';
export default class ForgetPwdAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  /**
   * @param {string} email - the email used to recall password
   * @return {Promise} send result
   */
  sendEmailCode = (params: { email: string; extra_params?: object }) => {
    const { email, extra_params = {} } = params;
    const data = encryptParams({ email, type: 4, ...extra_params }, [
      'email',
      'type',
    ]);
    return this.request({
      url: WEB_AFF_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data,
    });
  };
  /**
   * @param {string} mobile - the mobile used to recall password
   * @return {Promise} send result
   */
  sendMobileCode = (params: { mobile: string; extra_params?: object }) => {
    const { mobile, extra_params = {} } = params;
    const data = encryptParams({ mobile, type: 6, ...extra_params }, [
      'mobile',
      'type',
    ]);
    return this.request({
      url: WEB_AFF_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} mobile - the mobile used to reset password
   * @param {string} code - the captcha
   * @param {string} password - new password
   * @return {Promise} reset result
   */
  mobileReset = (params: {
    mobile: string;
    code: string;
    password: string;
    extra_params?: object;
  }) => {
    const { mobile, code, password, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, password, ...extra_params }, [
      'mobile',
      'code',
      'password',
    ]);
    return this.request({
      url: WEB_AFF_URL.RESET_BY_MOBILE,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} email - the email used to reset password
   * @param {string} code - the captcha
   * @param {string} password - new password
   * @return {Promise} reset result
   */
  emailReset = (params: {
    email: string;
    code: string;
    password: string;
    extra_params?: object;
  }) => {
    const { email, code, password, extra_params = {} } = params;
    const data = encryptParams({ email, code, password, ...extra_params }, [
      'email',
      'code',
      'password',
    ]);
    return this.request({
      url: WEB_AFF_URL.RESET_BY_EMAIL,
      method: 'POST',
      data,
    });
  };
}
